import { render, staticRenderFns } from "./Cockpit.vue?vue&type=template&id=3c9ddae6&scoped=true&"
import script from "./Cockpit.vue?vue&type=script&lang=js&"
export * from "./Cockpit.vue?vue&type=script&lang=js&"
import style0 from "./Cockpit.vue?vue&type=style&index=0&id=3c9ddae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9ddae6",
  null
  
)

export default component.exports